import * as api from "../../../api";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import {
  CheckCircleOutline,
  ErrorOutline,
  HourglassEmpty,
  NoteAddOutlined,
  PeopleAltOutlined,
  PanToolOutlined,
  Search,
  TranslateOutlined,
  TrendingUp,
  DataUsage,
  CancelOutlined,
  ThumbUpOutlined,
  CloudDoneOutlined,
  ReceiptOutlined,
  WorkOutlineOutlined,
  AssignmentTurnedInOutlined,
} from "@material-ui/icons";

import Profile from "../../Translator/Profile/Profile";
import Details from "../Details/Details";

import { ALERT } from "../../../constants/actionTypes";

import "./Index.css";

const Index = () => {
  const dispatch = useDispatch();
  const counter = useSelector((state) => state.counter);
  const [quoteFocused, setQuoteFocused] = useState(false);
  const [userFocused, setUserFocused] = useState(false);
  const [email, setEmail] = useState("");
  const [quoteId, setQuoteId] = useState("");
  const [showProfile, setShowProfile] = useState(false);
  const [profile, setProfile] = useState({});
  const [fetchingUser, setFetchingUser] = useState(true);
  const [fetchingQuote, setFetchingQuote] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [quote, setQuote] = useState({});

  const handleFetchUser = async (e) => {
    e.preventDefault();
    setShowProfile(true);

    try {
      const { data } = await api.getUser({ email });
      setProfile(data);
      setFetchingUser(false);
    } catch (error) {
      setShowProfile(false);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  const handleFetchQuote = async (e) => {
    e.preventDefault();
    setShowDetails(true);

    try {
      const { data } = await api.getOneQuote({ quote_id: quoteId });
      setQuote(data);
      setFetchingQuote(false);
    } catch (error) {
      setShowDetails(false);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  return (
    <>
      {showDetails && (
        <Details
          quote={quote}
          showDetails={showDetails}
          setShowDetails={setShowDetails}
          loading={fetchingQuote}
          preview
        />
      )}
      {showProfile && (
        <Profile
          user={profile}
          loading={fetchingUser}
          setShowProfile={setShowProfile}
          noFxn
          admin
        />
      )}
      <div className="index">
        <h2 className="mb-40 py-20 font-subhead">ADMIN DASHBOARD</h2>
        <div className="index__cards">
          <div className="index__projects py-20 px-40">
            <p className="font-big font-bold">Projects</p>
            <div className="d-flex flex-wrap">
              <Link
                to="/admin/pending"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <ErrorOutline className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Pending Projects
                  </span>
                </div>
                <span
                  style={{ background: "rgb(255, 205, 220)", color: "red" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.pending_projects}
                </span>
              </Link>
              <Link
                to="/admin/urgent"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <HourglassEmpty className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Urgent Projects
                  </span>
                </div>
                <span
                  style={{ background: "rgb(255, 175, 200)", color: "crimson" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.urgent_projects}
                </span>
              </Link>
              <Link
                to="/admin/unapproved"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <PanToolOutlined className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Unapproved Translators
                  </span>
                </div>
                <span
                  style={{ background: "rgb(255, 145, 180)", color: "darkred" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.unapproved_translators}
                </span>
              </Link>
              <Link
                to="/admin/declined"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <CancelOutlined className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Declined Allocations
                  </span>
                </div>
                <span
                  style={{ background: "rgb(255, 115, 160)", color: "darkred" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.declined_allocations}
                </span>
              </Link>
              <Link
                to="/admin/unassigned"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <NoteAddOutlined className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Unassigned Projects
                  </span>
                </div>
                <span
                  style={{ background: "rgb(255, 236, 200)", color: "orange" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.unassigned_projects}
                </span>
              </Link>
              <Link
                to="/admin/allocations"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <DataUsage className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Incomplete Allocations
                  </span>
                </div>
                <span
                  style={{ background: "rgb(255, 236, 200)", color: "orange" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.incomplete_allocations}
                </span>
              </Link>
              <Link
                to="/admin/ongoing"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <TrendingUp className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Ongoing Projects
                  </span>
                </div>
                <span
                  style={{ background: "rgb(223, 255, 223)", color: "green" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.ongoing_projects}
                </span>
              </Link>
              <Link
                to="/admin/completed"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20  rounded"
              >
                <div className="d-flex align-center">
                  <CheckCircleOutline
                    className="icon-orange"
                    fontSize="small"
                  />
                  <span className="pl-5 font-sm font-bold">
                    Completed Translations
                  </span>
                </div>
                <span
                  style={{
                    background: "rgb(205, 255, 205)",
                    color: "darkgreen",
                  }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.completed_projects}
                </span>
              </Link>
              <Link
                to="/admin/verified"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <ThumbUpOutlined className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Verified Projects
                  </span>
                </div>
                <span
                  style={{ background: "lightgreen", color: "green" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.verified_projects}
                </span>
              </Link>
              <Link
                to="/admin/concluded"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <CloudDoneOutlined className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">
                    Concluded Projects
                  </span>
                </div>
                <span
                  style={{ background: "yellowgreen", color: "white" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.concluded_projects}
                </span>
              </Link>
              <Link
                to="/admin/new-requests"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <ReceiptOutlined className="icon-orange" fontSize="small" />
                  <span className="pl-5 font-sm font-bold">New Requests</span>
                </div>
                <span
                  style={{ background: "rgb(255, 236, 200)", color: "orange" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.new_requests}
                </span>
              </Link>
              <Link
                to="/admin/ongoing-requests"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <WorkOutlineOutlined
                    className="icon-orange"
                    fontSize="small"
                  />
                  <span className="pl-5 font-sm font-bold">
                    Ongoing Requests
                  </span>
                </div>
                <span
                  style={{ background: "rgb(223, 255, 223)", color: "green" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.ongoing_requests}
                </span>
              </Link>
              <Link
                to="/admin/concluded-requests"
                className="index__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded"
              >
                <div className="d-flex align-center">
                  <AssignmentTurnedInOutlined
                    className="icon-orange"
                    fontSize="small"
                  />
                  <span className="pl-5 font-sm font-bold">
                    Concluded Requests
                  </span>
                </div>
                <span
                  style={{ background: "yellowgreen", color: "white" }}
                  className="font-bolder ml-auto text-right px-20 mt-5 curved-20"
                >
                  {counter.concluded_requests}
                </span>
              </Link>
            </div>
          </div>
          <div className="index__memebers py-20 px-40 pt-40">
            <p className="font-big font-bold">Management</p>
            <div className="d-flex flex-wrap">
              <div className="index__card d-flex flex-column justify-center box-shadow-lg p-20 mt-20 mr-20 rounded">
                <div className="d-flex align-center justify-center">
                  <TranslateOutlined className="icon-orange" />
                  <span className="pl-10 font-bold">Translators</span>
                </div>
                <span
                  style={{ background: "#f9f9f9", color: "#ff5e15" }}
                  className="ml-auto text-right px-20 mt-5 font-bolder rounded"
                >
                  {counter.total_translators}
                </span>
              </div>
              <div className="index__card d-flex flex-column justify-center box-shadow-lg p-20 mt-20 mr-20 rounded">
                <div className="d-flex align-center justify-center">
                  <PeopleAltOutlined className="icon-orange" />
                  <span className="pl-10 font-bold">Clients</span>
                </div>
                <span
                  style={{ background: "#f9f9f9", color: "#ff5e15" }}
                  className="ml-auto text-right px-20 mt-5 font-bolder rounded"
                >
                  {counter.total_clients}
                </span>
              </div>
              <div
                style={{
                  background: quoteFocused ? "#fff" : "#ff5e15",
                  color: "#fff",
                  width: quoteFocused ? "320px" : "",
                }}
                className="index__search index__card d-flex flex-column justify-center mt-20 mr-20 rounded box-shadow-lg"
              >
                <div className="d-flex align-center justify-between h-100">
                  <form onSubmit={handleFetchQuote}>
                    <label className="d-flex align-center justify-center h-100">
                      {!quoteFocused && (
                        <Search className="ml-10" fontSize="large" />
                      )}
                      <input
                        style={{ color: quoteFocused ? "#333" : "#fff" }}
                        placeholder={
                          quoteFocused ? "Enter quote ID" : "Find Quote"
                        }
                        className="index__input bg-transparent border-0 outline-0 font-bigger w-100 pl-10 font-bolder"
                        value={quoteId}
                        onFocus={() => setQuoteFocused(true)}
                        onBlur={() => {
                          setQuoteFocused(false);
                          setQuoteId("");
                        }}
                        onChange={(e) => setQuoteId(e.target.value)}
                      />
                    </label>
                  </form>
                </div>
              </div>
              <div
                style={{
                  background: userFocused ? "#fff" : "#ff5e15",
                  color: "#fff",
                  width: userFocused ? "320px" : "",
                }}
                className="index__search index__card d-flex flex-column justify-center mt-20 mr-20 rounded box-shadow-lg"
              >
                <div className="d-flex align-center justify-between h-100">
                  <form onSubmit={handleFetchUser}>
                    <label className="d-flex align-center justify-center h-100">
                      {!userFocused && (
                        <Search className="ml-10" fontSize="large" />
                      )}
                      <input
                        style={{ color: userFocused ? "#333" : "#fff" }}
                        placeholder={userFocused ? "Enter email" : "Find User"}
                        className="index__input bg-transparent border-0 outline-0 font-bigger w-100 pl-10 font-bolder"
                        value={email}
                        onFocus={() => setUserFocused(true)}
                        onBlur={() => {
                          setUserFocused(false);
                          setEmail("");
                        }}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </label>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
